var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"electron-technology"},[_c('s-r-m-header',{ref:"header"}),_c('IndustryDesc',{ref:"industryDesc",attrs:{"industryInfo":_vm.industryInfo,"show-menu":"","title-up":""}}),_c('ProjectDesc',{attrs:{"descInfo":{
        title: '医疗器械行业研发现状',
        description: '璞华易研PLM提供适用于医疗器械行业的研发管理解决方案',
        redContent: '我国医疗器械行业',
        content: ' 21 世纪以来飞速发展，逐渐由最初以生产加工为主的工厂型向更加全面的、技术含量更高的制造业转变。医疗器械行业对产品安全性和有效性要求特别高，因此对产品的设计、生产过程要求尤其严格。 医疗器械制造商的竞争日趋激烈，使得企业在产品管理方面迫切需要通过一种更为系统化、更为全面、更高效的产品生命周期管理广法以及对应的管理平台来迎接这些新挑战。璞华易研PLM系统帮助医疗器械企业全面管理产品生命周期，提升企业的研发管理水平。'
      }}}),_c('ProblemSolving',{attrs:{"isPercentage":false,"textList":_vm.textList}}),_c('LifeCycle',{attrs:{"title":"医疗器械的产品生命周期管理(PLM)","description":"璞华易研PLM帮助医疗企业构建完整的研发体系平台","listData":_vm.listData}}),_c('CompanyInfo',{attrs:{"projectInfo":_vm.projectInfo}}),_c('ResultsOperation',{attrs:{"descInfo":{
        title: '运营效果',
        descArr1: [
          '依托项目管理平台，优化、规范企业标准，减少错误',
          '实现企业CSV认证，提高数据的合规性、高效性',
          '实现知识共享，提高研发、项目管理水平',
        ],
        descArr2: [
          '产品的DHF和DMR等文件与产品进行关联，可从本地或者通过模板进行新增，完成产品文件的管理。',
          '打通各系统之间信息孤岛，连通企业各系统，使业务数据有效流动',
        ]
      }}}),_c('ChooseUs',{attrs:{"nameVals":['MedicalEquipment'],"scrollNum":2}}),_c('custom-form',{ref:"customForm"}),_c('footer-box')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }